module.exports = __webpack_public_path__ + "static/media/pin_idle.db9b7f25.png";